<template>
  <div>
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="开始时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择结束时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时间节点" size="small" label-width="70px">
              <el-select v-model="searchForm.type" filterable placeholder="请选择类型" >
                <el-option v-for="item in typeData" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="关键字" size="small" label-width="70px">
              <el-input v-model="searchForm.keyword" placeholder="车主姓名|车牌号|运输公司" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <shopCompanyTemp ref="shopCompanyTemp" @changeData="setshopId" ></shopCompanyTemp>
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table ref="multipleTable" :data="tableLoadData" stripe border size="mini" :header-cell-style="{background:'#e5e5e5',color:'#333333'}">
        <el-table-column
            label="ID"
            min-width="5%"
            prop="id"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="经办人"
            min-width="10%"
            prop="op_name"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="车牌"
            min-width="10%"
            prop="plate_number"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="车主"
            min-width="10%"
            prop="allPerson"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车架"
            min-width="10%"
            prop="car_info.vin"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车型"
            min-width="10%"
            prop="car_info.model"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="发证日期"
            min-width="10%"
            prop="car_info.issue_date"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="注册日期"
            min-width="10%"
            prop="car_info.register_date"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="等级名称"
            min-width="10%"
            prop="name"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="联系电话"
            min-width="10%"
            prop="mobile"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="收费金额"
            min-width="10%"
            prop="fee"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="评定人姓名"
            min-width="10%"
            prop="audit_name"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="下次评定日期"
            min-width="10%"
            prop="next_time"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.next_time | dateFormat }}</template>
        </el-table-column>

        <el-table-column
            label="备注"
            min-width="10%"
            prop="remark"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="操作"

            width="130">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <carListTemp ref="carListTemp" :carId="form.car_id" @changeData="setcarInfo"></carListTemp> <!--@changeData="setplateNumber"-->
          </el-col>
          <el-col :span="7">
            <el-form-item label="车主姓名" prop="" size="small">
              <el-input v-model="form.allPerson" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="车架号" prop="" size="small">
              <el-input v-model="form.vin" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车型" prop="" size="small">
              <el-input v-model="form.model" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发证日期" prop="" size="small">
              <el-input v-model="form.issue_date" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册日期" prop="" size="small">
              <el-input v-model="form.register_date" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="等级名称" prop="" size="small">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评定人ID" size="small">
              <el-select v-model="form.audit_uid" filterable placeholder="请选择评定人" >
                <el-option v-for="item in auditData" :key="item.id" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="下次评定日期" prop="next_time"  size="small">
              <el-date-picker v-model="form.next_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="" size="small">
              <el-input v-model="form.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="收费金额" prop="fee" size="small">
              <el-input v-model="form.fee" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="" size="small">
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <!--
          <el-col :span="12">
            <el-form-item label="车牌" prop="" size="small" >
              <el-input v-model="form.plate_number" autocomplete="off" readonly class="setValue"></el-input>
            </el-form-item>
          </el-col>-->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment';    //日期时间转换
import eCar from "../common/eCar";
import shopCompanyTemp from "../common/shopCompanyTemp.vue";
import carListTemp from "../common/carlistTemp.vue";
export default {
  name: "shipCompany",
  components: {
    eTable,
    eCar,
    shopCompanyTemp,
    carListTemp
  },
  props: {},
  data() {
    return {
      isShowCar:false,
      // 搜索
      searchForm: {
        keyword:'',
        start_time:'',
        end_time:'',
        shop_id:'',
        type:''
      },
      typeData:[
        {
          id:1,
          name:'代表30天内到期'
        },
        {
          id:2,
          name:'全部'
        }],
      searchRules: {
      },
      // 数据
      tableLoadData: [],
      auditData:[],
      limit: 10,
      page:1,// 当前页码
      total:0,//总条目数
      id: '',
      rules: {
        //allPerson:[{ required: true, message: "请输入所属人", trigger: "blur" }],
        fee:[{required: true, message: '请输入费用', trigger: 'blur' },
          {pattern:'([1-9]\\d*(\\.\\d*[1-9])?)|(0\\.\\d*[1-9])',message: '费用必须大于0',trigger: 'blur'}
        ],
      },
      dialogFormVisible: false,
      title: '',
      form: {
        car_id:'',
        //shop_id:'',
        mobile:'',
        //allPerson :'',
        fee :'',
        //plate_number:'',
        next_time:'',
        remark:'',
        name: "",
        audit_uid: '',
        audit_name: ""
      },
      uploadImg: '',
      uploadDialog: false
    };
  },
  created() {
    this.DataList()
    this.getAuditData()
  },
  mounted() {

  },
  filters: {
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
  },
  methods: {
    setcarInfo(value){
      this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
      this.form.vin = value.vin
      this.form.model = value.model
      this.form.issue_date = value.issue_date
      this.form.register_date = value.register_date
    },
    setshopId(value){
      //this.form.plate_number = value
      this.searchForm.shop_id = value
    },
    //auditData
    getAuditData() {
      ////console.log(123)
      ////console.log(this.$parent.$parent.$parent.getAuditData());
      //this.auditData = this.$parent.$parent.$parent.getAuditData()
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getAssessor(param).then(res=>{
        if(res.code == 200){
          ////console.log(res.data.data);
          this.auditData = res.data.data
          //return res.data.data
        }
      }).catch(error=>{
        // return
        //console.log(error);
      })
    },
    setplateNumber(value){
      this.form.plate_number = value
    },
    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize:this.limit
      }
      if(this.searchForm.shop_id) param.shop_id =  this.searchForm.shop_id
      if(this.searchForm.type) param.type =  this.searchForm.type
      if(this.searchForm.start_time) param.start_time =  this.getTime(this.searchForm.start_time)
      if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)

      this.$axios.getGradeFee(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        // role_name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      this.id = index.id

      this.title = '编辑'
      this.form = {
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index))
      this.form.next_time = this.form.next_time*1000
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            name: this.form.name,
            audit_uid: this.form.audit_uid,
            audit_name: this.form.audit_name,
            car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
            //shop_id: this.$refs.shopCompanyTemp.form.shop_id,//this.form.shop_id,
            allPerson:this.form.allPerson,
            fee :this.form.fee,
            plate_number:this.form.plate_number,
            next_time:this.form.next_time,
            remark:this.form.remark,
            mobile: this.form.mobile,
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token')
          }
          if(this.id) param.id = this.form.id
          this.$axios.saveGradeFee(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.dialogFormVisible = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    searchSubmit() {
      this.page = 1
      this.DataList()
    },

    handelDel(e) {
      this.$confirm('此操作将删除该车辆等级评定费信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.id,
        }
        //console.log(param);
        this.$axios.delOccupational(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
        // 点击取消:不删除了
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
        this.DataList()
      });
      this.teamDialog = false
    }
  },
};
</script>
<style>
.table_name{
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/common/gradeFee.vue